import { ENV_VARIABLES } from "../Config/env-config";

export const r2cIdsConfig = {
  issuer: ENV_VARIABLES.REACT_APP_CLIENT_ISSUER_R2C,
  referrerUrl: ENV_VARIABLES.REACT_APP_CLIENT_REFERRER_R2C,
};

export const oneLinkIdsConfig = {
  issuer: ENV_VARIABLES.REACT_APP_CLIENT_ISSUER_1LINK,
  referrerUrl: ENV_VARIABLES.REACT_APP_CLIENT_REFERRER_1LINK,
};

export const imsIdsConfig = {
  grant_type: ENV_VARIABLES.REACT_APP_GRANT_TYPE,
  client_id: ENV_VARIABLES.REACT_APP_CLIENT_ID,
  scope: ENV_VARIABLES.REACT_APP_CLIENT_SCOPE,
  issuer: ENV_VARIABLES.REACT_APP_CLIENT_ISSUER,
};
